module.exports = __webpack_public_path__ + "static/media/266.39767c04.webp";